import React from 'react';
import classNames from 'classnames';

import CoreLink from './core_link';
import SanitizedRender from './sanitized_render';
import CMSSearchInputGroup from './cms_search_input_group';
import BreadcrumbNavigation, { BreadcrumbData } from '../cms/components/breadcrumb_navigation';

const BACKGROUND_STYLES = {
  style3: 'orange',
  style4: 'blue',
  style5: 'blue-lp',
  style6: 'no-bg',
};

interface IProps {
  title: string;
  subtitle: string;
  backgroundImage?: string;
  headerStyle: 'style3' | 'style4' | 'style5' | 'style6';
  actionUrl?: string;
  actionText?: string;
  searchOverride?: Function;
  searchPlaceholder?: string;
  breadcrumbs?: Array<BreadcrumbData>;
}

export default class BasicPageHead extends React.Component<IProps, null> {
  getBackgroundStyle() {
    if (!this.props.backgroundImage) { return null; }

    return {
      style: { backgroundImage: `url('${this.props.backgroundImage}')` },
    };
  }

  getBackgroundStyleClass(style) {
    if (this.props.backgroundImage) return null;

    return {
      [`page-hero--${BACKGROUND_STYLES[style]}`]: this.props.headerStyle === style,
    };
  }

  renderSearchArea() {
    if (!this.props.actionUrl) return null;

    return (
      <div className="page-hero__search">
        <div className="scaling-mt-6 mb-2">
          <CMSSearchInputGroup
            placeholder={this.props.searchPlaceholder}
            searchOverride={this.props.searchOverride}
            actionUrl={this.props.actionUrl}
            largeInput
          />
        </div>
        {this.props.actionText &&
          <div className="page-hero__search-action">
            <CoreLink
              to={this.props.actionUrl}
            >
              {this.props.actionText}
            </CoreLink>
          </div>
        }
      </div>
    );
  }

  subtitleHtmlTag() {
    if (this.props.headerStyle === 'style6') {
      return 'h3';
    }

    return 'h2';
  }

  render() {
    const classes = classNames(
      'page-hero',
      { 'page-hero--photo-fill': !!this.props.backgroundImage },
      { 'page-hero--with-search': !!this.props.actionUrl },
      { ...this.getBackgroundStyleClass('style3') },
      { ...this.getBackgroundStyleClass('style4') },
      { ...this.getBackgroundStyleClass('style5') },
      { ...this.getBackgroundStyleClass('style6') },
    );

    return (
      <header
        className={classes}
        {... this.getBackgroundStyle()}
      >
        {!!this.props.breadcrumbs?.length && <BreadcrumbNavigation breadcrumbs={this.props.breadcrumbs} />}
        <SanitizedRender
          htmlTag="h1"
          className="page-hero__title"
          html={this.props.title}
          inlineTagsOnly
        />
        {this.props.subtitle &&
          <SanitizedRender
            htmlTag={this.subtitleHtmlTag()}
            className="page-hero__subtitle"
            html={this.props.subtitle}
            inlineTagsOnly
          />
        }
        {this.renderSearchArea()}
      </header>
    );
  }
}
